import { render, staticRenderFns } from "./minimal-full-width.vue?vue&type=template&id=2ca62f74"
import script from "./minimal-full-width.vue?vue&type=script&lang=js"
export * from "./minimal-full-width.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports